export default {
  meta: {
    title: '即插即踩',
    url: '/passenger/index', // 埋点字段，上报归属的模块
    urlName: '即插即踩' // 埋点字段，上报归属的模块
  }
};
